import React, { useState, useEffect } from 'react';
import { supabaseClient } from '../../services/supabase';

function BusinessHours() {
  const [start, setStart] = useState(11);
  const [end, setEnd] = useState(22);
  const [lastOrder, setLastOrder] = useState(21.5);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const { data, error } = await supabaseClient
        .from('store_settings')
        .select('setting_key, setting_value')
        .eq('setting_key', 'business_hours')
        .single();

      if (error && error.code !== 'PGRST116') {
        console.error('営業時間設定読み込みエラー:', error);
        return;
      }

      if (data && data.setting_value) {
        const hours = data.setting_value;
        setStart(hours.start || 11);
        setEnd(hours.end || 22);
        setLastOrder(hours.last_order || 21.5);
      }
    } catch (error) {
      console.error('営業時間設定読み込みエラー:', error);
    }
  };

  const saveSettings = async () => {
    setLoading(true);
    try {
      const businessHours = {
        start: parseInt(start),
        end: parseInt(end),
        last_order: parseFloat(lastOrder),
      };

      const { error } = await supabaseClient
        .from('store_settings')
        .upsert(
          {
            setting_key: 'business_hours',
            setting_value: businessHours,
          },
          {
            onConflict: 'setting_key',
          }
        );

      if (error) throw error;
      alert('営業時間設定を保存しました。');
    } catch (error) {
      console.error('営業時間設定保存エラー:', error);
      alert('営業時間設定の保存に失敗しました。');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="admin-section">
      <div className="container">
        <h2>営業時間/休日設定</h2>
        <div className="settings-form">
          <h3>営業時間設定</h3>
          <div className="form-group">
            <label>営業時間（開始）</label>
            <input
              type="number"
              id="businessHoursStart"
              min="0"
              max="23"
              value={start}
              onChange={(e) => setStart(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>営業時間（終了）</label>
            <input
              type="number"
              id="businessHoursEnd"
              min="0"
              max="23"
              value={end}
              onChange={(e) => setEnd(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>ラストオーダー</label>
            <input
              type="number"
              step="0.5"
              id="lastOrder"
              value={lastOrder}
              onChange={(e) => setLastOrder(e.target.value)}
            />
          </div>
          <button
            id="saveSettings"
            className="btn-primary"
            onClick={saveSettings}
            disabled={loading}
          >
            {loading ? '保存中...' : '設定を保存'}
          </button>
        </div>
      </div>
    </section>
  );
}

export default BusinessHours;

